import { XIcon } from '@heroicons/react/outline';
import { Modal } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import ExclamationErrorIcon from 'assets/Icons/ExclamationErrorIcon';
import React from 'react';

import ButtonDefault, {
  ButtonVariants,
} from '@/components/shared/basic/button';

interface RedeemErrorModalProps {
  isVisible: boolean;
  onClose: () => void;
  onRaiseConcern: () => void;
}

const RedeemErrorModal: React.FC<RedeemErrorModalProps> = ({
  isVisible,
  onClose,
  onRaiseConcern,
}) => {
  const screens = useBreakpoint();
  return (
    <Modal
      open={isVisible}
      onCancel={onClose}
      footer={null}
      centered
      width={500}
      closeIcon={<XIcon className='text-white w-5 h-5' />}
      className='redeem-error-modal'
      styles={{
        content: {
          backgroundColor: '#121212',
          borderRadius: '16px',
          padding: '24px',
          paddingBottom: screens.md ? '40px' : '24px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
        },
      }}
    >
      <div className='flex flex-col items-center justify-center w-full text-center'>
        <div className='w-16 h-16 rounded-full bg-red-900 flex items-center justify-center'>
          <ExclamationErrorIcon />
        </div>
        <div className='py-6 flex flex-col  '>
          <h2 className='text-white text-base md:text-xl font-semibold mb-2 text-center mx-auto max-w-[50vw] md:max-w-full'>
            You have already redeemed your book
          </h2>

          <p className='text-grayZl-500 text-sm md:text-base font-light '>
            Kindly add different Amazon order id.
          </p>
        </div>

        <div className='flex flex-col-reverse md:flex-row gap-2 w-full max-w-[300px]'>
          <ButtonDefault
            size={4}
            rounded={false}
            roundedSm={true}
            className='md:w-1/3'
            onClick={onClose}
            variant={ButtonVariants.GRAY}
          >
            <span className='flex text-sm gap-x-2 text-white px-4 whitespace-nowrap'>
              Close
            </span>
          </ButtonDefault>
          <ButtonDefault
            size={4}
            rounded={false}
            roundedSm={true}
            onClick={onRaiseConcern}
            className='md:w-2/3'
            variant={ButtonVariants.WHITE}
          >
            <span className='flex text-sm gap-x-2 px-4 font-semibold whitespace-nowrap'>
              Raise a Concern
            </span>
          </ButtonDefault>
        </div>
      </div>
    </Modal>
  );
};

export default RedeemErrorModal;
